import React from "react";
import Log from "../../assets/img/log.jpeg";

function Navbar() {
  return (
    <>
      <div className="" id="google_translate_element"></div>
      <div className="header-nav">
        <nav className="navbar fixed-top navbar-expand-sm navbar-light">
          {" "}
          <a className="navbar-brand col-5 pl-lg-5 col-lg-2" href="#">
            <img src={Log} className="logo" alt="logo" />
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div
            className="collapse navbar-collapse mt-3"
            id="navbarSupportedContent"
          >
            <ul className="nav navbar-nav">
              <li className="nav-item ">
                <a
                  className="nav-link"
                  href="/#/"
                  data-spy="scroll"
                  data-target="#whyCiv"
                >
                  Pourquoi CIVWifi
                </a>
              </li>

              <li className="nav-item ">
                <a className="nav-link" href="/civwifi/#/for_homes">
                  Pour les maisons
                </a>
              </li>

              {/* <li className="nav-item ">
      <a className="nav-link" href="http://ghanawifi.com/news">
        Blog
      </a>
    </li> */}
            </ul>
            <ul className="nav navbar-nav">
              <li className="nav-item ">
                <a className="nav-link" href="/civwifi/#/for_business">
                  Pour les entreprises
                </a>
              </li>
              <li className="nav-item ">
                <a className="nav-link" href="/civwifi/#/faq">
                  FAQ
                </a>
              </li>
            </ul>

            <ul className="nav navbar-nav navbar-right ml-auto pr-lg-5">
              <li className="nav-item ">
                <a className="nav-link" href="/civwifi/#/pricing">
                  Tarification
                </a>
              </li>

              {/* <li className="nav-item ">
                <a className="nav-link" href="/#/contact">
                  Contactez-nous
                </a>
              </li> */}
              <li className="nav-item ">
                <a className="nav-link" href="#">
                  Connexion
                </a>
              </li>
              <li className="nav-item ">
                <a className="nav-link" id="sign-up" href="/civwifi/#/sign-up">
                  S'inscrire
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </>
  );
}

export default Navbar;
